import { render, staticRenderFns } from "./b-menu-back-bubble.vue?vue&type=template&id=81e4ebc6&scoped=true&"
import script from "./b-menu-back-bubble.vue?vue&type=script&lang=js&"
export * from "./b-menu-back-bubble.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-back-bubble.vue?vue&type=style&index=0&id=81e4ebc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e4ebc6",
  null
  
)

export default component.exports